import {useTranslation} from 'react-i18next';
import {SupportAvatar} from './SupportAvatar';
import {firstNameOf} from './supportTeamIdentity';

// SupportIncomingCard — el mensaje del equipo que aparece SOLO junto a la burbuja, como el mensaje
// entrante de Intercom (parte A2 de «conversaciones con usuarios»).
//
// Es la misma conversación del chat, mostrada como tarjeta: no hay un sistema de notificaciones
// aparte. Dos salidas:
//   - «Responder» abre el chat en esa conversación (lo que escriba ya es el ticket).
//   - «Entendido» la marca como leída y la cierra (el «archivar/aceptar»).
// Escape (con el foco adentro) la oculta hasta el próximo mensaje, sin marcarla como leída.
//
// No roba el foco: se llega con Tab, y el lector de pantalla la anuncia por la región `role="status"`
// que la burbuja deja siempre montada (una región `aria-live` que se inserta ya con su texto no se
// anuncia de forma confiable). La clase raíz `support-incoming-card` es además la marca para
// verificar el deploy (el copy no viaja en el bundle).
//
// Props:
//   item: {conversation_id, message: {id, author_name, author_avatar_url, body}} — el más reciente.
//   moreCount: cuántas otras conversaciones tienen un mensaje del equipo sin leer.
//   onReply(item), onAcknowledge(item), onDismiss(item)

// «Fede · equipo de Dashbo», o «Equipo de Dashbo» si el mensaje no trae autor (no «Dashbo · equipo
// de Dashbo»). Lo usa también la burbuja para anunciar la tarjeta.
export function incomingFromText(t, message) {
    const firstName = firstNameOf(message.author_name || '');
    if (!firstName) return t('support_chat.incoming_from_team');
    return t('support_chat.incoming_from', {name: firstName, interpolation: {escapeValue: false}});
}

export const SupportIncomingCard = ({item, moreCount = 0, onReply, onAcknowledge, onDismiss}) => {
    const {t} = useTranslation();
    const message = item.message || {};
    const authorName = message.author_name || '';

    const onKeyDown = (e) => {
        if (e.key === 'Escape') {
            e.stopPropagation();
            onDismiss(item);
        }
    };

    return (
        <section
            className="support-incoming-card"
            aria-label={t('support_chat.incoming_label')}
            onKeyDown={onKeyDown}
        >
            <div className="support-incoming-card__head">
                <SupportAvatar name={authorName} avatarUrl={message.author_avatar_url} size={32} team/>
                <span className="support-incoming-card__from">{incomingFromText(t, message)}</span>
            </div>
            {/* Un mensaje con sólo un adjunto no deja la tarjeta sin cuerpo: el adjunto se abre en el chat. */}
            <p className="support-incoming-card__body">
                {message.body || (message.attachment_url ? t('support_chat.incoming_attachment_only') : '')}
            </p>
            {moreCount > 0 && (
                <p className="support-incoming-card__more">
                    {t('support_chat.incoming_more', {count: moreCount})}
                </p>
            )}
            <div className="support-incoming-card__actions">
                <button
                    type="button"
                    className="support-incoming-card__ack"
                    onClick={() => onAcknowledge(item)}
                >
                    {t('support_chat.incoming_ack')}
                </button>
                <button
                    type="button"
                    className="support-incoming-card__reply"
                    onClick={() => onReply(item)}
                >
                    {t('support_chat.incoming_reply')}
                </button>
            </div>
        </section>
    );
};
